import { toMoney } from "shared/utils";
import { UploadedIncomeSource } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";
import { VerifiedItem } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified";
import { IncomeField } from "./types";
import { form1099Formula } from "./form1099Formula";

export const Form1099Tooltip = ({
  items,
  field,
  sources,
  displayedMonthly
}: {
  items: VerifiedItem[];
  field: IncomeField;
  sources?: Pick<UploadedIncomeSource, "id" | "status">[];
  displayedMonthly: number;
}) => {
  const formula = form1099Formula(items, field, sources);
  if (!formula) return null;

  return (
    <>
      Verified {field} monthly calculation
      <br />
      {formula} = {toMoney(displayedMonthly)}
    </>
  );
};
